import * as React from 'react'

import { Form } from 'factorial-form'
import { ContractFlowCustomFieldFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import TextInput from 'modules/core/components/Inputs/Text'

import { getCustomFieldKey } from 'modules/contracts/lib/customFields'

interface Props {
  form: Form
  field: ContractFlowCustomFieldFragment
}

const CentsCustomField = ({ form, field }: Props) => {
  return (
    <TextInput
      type="number"
      mandatory={field.required ?? false}
      label={field.labelText}
      field={form.get(getCustomFieldKey(field))}
    />
  )
}

export default observer(CentsCustomField)
